import React from 'react';
// @ts-ignore
import RemoveConfirmation from './RemoveConfirmation';
import Modal from '../Modal';

interface Props {
	opened: boolean;
	onClose: () => void;
	onConfirm: () => void;
	confirmationText?: string;
	confirmationTitle?: string;
}

const RemoveConfirmationModal: React.FC<Props> = ({
																										opened,
																										onClose,
																										onConfirm,
																										confirmationText,
																										confirmationTitle = 'base.shared.notice',
																									}) => {
	return (
		<div>
			<Modal opened={opened} onClose={onClose}>
				<Modal.Header title={confirmationTitle} />
				<Modal.Content>
					<RemoveConfirmation
						onConfirm={onConfirm}
						onAbort={onClose}
						confirmationText={confirmationText}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
};

export default RemoveConfirmationModal;